import React from 'react';
import PropTypes from 'prop-types';

const MultipleChoiceCheckbox = ({
  onChange, value, name, checked, disabled,
}) => (
  <input
    type="checkbox"
    onChange={onChange}
    value={value}
    name={name}
    checked={checked}
    disabled={disabled}
  />
);

MultipleChoiceCheckbox.defaultProps = {
  value: '',
  checked: false,
  disabled: false,
};

MultipleChoiceCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default MultipleChoiceCheckbox;
